import { render, staticRenderFns } from "./TakeWay.vue?vue&type=template&id=6cba5c44&scoped=true"
import script from "./TakeWay.vue?vue&type=script&lang=js"
export * from "./TakeWay.vue?vue&type=script&lang=js"
import style0 from "./TakeWay.vue?vue&type=style&index=0&id=6cba5c44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba5c44",
  null
  
)

export default component.exports